import React, { useEffect } from 'react';
import { clearFlashes } from 'redux/actions';
import Style from './InsuranceContainer.SuccessView.style';
import { useGetHealthInsuranceCooperation, useInsuranceFormType } from 'hookApi';
import { Image, Paragraph } from '@missionme/mime_elements';
import { successSda, successResilienz } from 'images/landingpages/health_insurance';
import FormHeader from 'components/Landingpages/FormHeader';
import { TEXT } from 'locales/translations';

import { useSelector } from 'react-redux';
import { isZppUserAlreadyApplied } from 'redux/query';

export const SuccessView = ({ children }) => {
  const formType = useInsuranceFormType();
  const { selectedOffer } = useGetHealthInsuranceCooperation();
  const zppAlreadyApplied = useSelector(isZppUserAlreadyApplied);
  const { successScreen } = TEXT.formsGeneral;

  useEffect(() => {
    clearFlashes();
  }, []);

  if (formType !== 'SuccessView') {
    return null;
  }

  if (!!children) {
    return <Style>{children}</Style>;
  }
  return (
    <Style className="text-center">
      <FormHeader
        className={`color-${selectedOffer?.slug}`}
        headline={zppAlreadyApplied ? successScreen.successHeadlineWelcomeBack : successScreen.successHeadline}
      />
      <Paragraph>
        <span className="bold">Schritt 1:</span>
        <br />
        Lade die Balloon-App herunter und öffne sie.
      </Paragraph>
      <Paragraph>
        <span className="bold">Schritt 2:</span>
        <br />
        Nutze für die Anmeldung in der App unbedingt die <span className="bold">Mail-Adresse, welche du gerade hier verwendet hast. </span>
      </Paragraph>
      <Paragraph>
        <span className="bold">Schritt 3:</span>
        <br />
        Du erhältst dann erneut einen Einmalcode per Mail, welchen du in der App eingeben musst.
      </Paragraph>
      {selectedOffer?.slug === 'sda' && <Image src={successSda} alt="Antistress-Coaching-Kurs" />}
      {selectedOffer?.slug === 'resilienz' && <Image src={successResilienz} alt="Resilienz-Kurs" />}
    </Style>
  );
};
